import React, { useContext } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import CustomDialog, { CustomDialogProps } from "../../../components/Dialog/CustomDialog";
import { ProductContext } from "../../../contexts/ProductContext";
import UnknownSampleAddForm from "./UnknownSampleAddForm";
import UnknownSampleAddFormType from "../../../api/models/product/UnknownSampleAddFormType";

type UnknownProduct = ProductRaw.Schemas.UnknownProductResponse;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      marginBottom: theme.spacing(5),
    },
  }),
);
interface ProductSampleAddUnknownProductDialogProps extends CustomDialogProps {
  onSelected: (unknownProduct: UnknownProduct) => void;
}

const ProductSampleAddUnknownProductDialog = (props: ProductSampleAddUnknownProductDialogProps) => {
  const { open, onClose, onSelected } = props;
  const classes = useStyles();
  const { updateUnknownProduct } = useContext(ProductContext);

  const submitForm = (values: UnknownSampleAddFormType) => {
    if (values.unknownProduct) {
      updateUnknownProduct(values.unknownProduct);
      onSelected(values.unknownProduct);
    } else {
      onClose();
    }
  };

  return (
    <CustomDialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
      <h2 className={classes.header}>ADD UNKNOWN PRODUCT</h2>
      <UnknownSampleAddForm handleSubmit={submitForm} />
    </CustomDialog>
  );
};

export default ProductSampleAddUnknownProductDialog;
